import { render, staticRenderFns } from "./ImportPrepost.vue?vue&type=template&id=4f0c0f3a"
import script from "./ImportPrepost.vue?vue&type=script&lang=js"
export * from "./ImportPrepost.vue?vue&type=script&lang=js"
import style0 from "./ImportPrepost.vue?vue&type=style&index=0&id=4f0c0f3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports